/**
 * Sx object for MUI Chip filled with a workflow status color (hex or CSS color string).
 * Returns null when empty or not a parseable 3/6-digit hex (falls back to theme Chip colors).
 */
export function statusColorChipSx(cssColor) {
  const raw = (cssColor || '').trim();
  if (!raw) return null;
  const rgb = parseHexToRgb(raw);
  const text = rgb ? pickContrastText(rgb.r, rgb.g, rgb.b) : '#fff';
  return {
    backgroundColor: raw,
    color: text,
    '& .MuiChip-label': { color: text },
  };
}

function parseHexToRgb(s) {
  let x = s.trim();
  if (x.startsWith('#')) x = x.slice(1);
  if (x.length === 3) {
    x = x
      .split('')
      .map((c) => c + c)
      .join('');
  }
  if (!/^[0-9a-fA-F]{6}$/.test(x)) return null;
  const n = parseInt(x, 16);
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
}

function pickContrastText(r, g, b) {
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 186 ? '#111' : '#fff';
}
